export default __webpack_public_path__ + "static/logo-PW-276f388b3792b6ba363f13839aff10a5.png";